import { defaultInitialState } from "shared/redux-store/defaultDataReducerParts";
import { createDataReducerSimpleFetch } from "shared/redux-store/defaults";
import reduceReducers from "reduce-reducers";
import _omitBy from "lodash/omitBy";
import { normalizeApi } from "shared/api";

// ToDo: Please generalize when implementing the next remove action
function submitRemoveReceiveSuccessState(state, action) {
  const deletedOrderUnit = normalizeApi(action.payload[0].data, "orderUnit");
  const newOrderUnits = _omitBy(
    state.orderUnits || {},
    orderUnit => orderUnit.id === deletedOrderUnit.id,
  );
  return { orderUnits: newOrderUnits };
}

const orderUnitsOverviewDataReducerFetch = createDataReducerSimpleFetch(
  "ORDER_UNITS_OVERVIEW",
  ["orderUnits", "products"],
);

function orderUnitsOverviewDataReducerSubmit(
  state = defaultInitialState(),
  action,
) {
  switch (action.type) {
    case "SUBMIT_ORDER_UNIT_REMOVE_FULFILLED":
      return {
        ...state,
        ...submitRemoveReceiveSuccessState(state, action),
      };
    default:
      return state;
  }
}

export default reduceReducers(
  orderUnitsOverviewDataReducerFetch,
  orderUnitsOverviewDataReducerSubmit,
);
